var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 18,
    viewBox: "0 0 9 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.375 4.5V13.125C7.375 13.9206 7.05893 14.6837 6.49632 15.2463C5.93371 15.8089 5.17065 16.125 4.375 16.125C3.57935 16.125 2.81629 15.8089 2.25368 15.2463C1.69107 14.6837 1.375 13.9206 1.375 13.125V3.75C1.375 3.25272 1.57254 2.77581 1.92417 2.42417C2.27581 2.07254 2.75272 1.875 3.25 1.875C3.74728 1.875 4.22419 2.07254 4.57583 2.42417C4.92746 2.77581 5.125 3.25272 5.125 3.75V11.625C5.125 11.8239 5.04598 12.0147 4.90533 12.1553C4.76468 12.296 4.57391 12.375 4.375 12.375C4.17609 12.375 3.98532 12.296 3.84467 12.1553C3.70402 12.0147 3.625 11.8239 3.625 11.625V4.5H2.5V11.625C2.5 12.1223 2.69754 12.5992 3.04917 12.9508C3.40081 13.3025 3.87772 13.5 4.375 13.5C4.87228 13.5 5.34919 13.3025 5.70083 12.9508C6.05246 12.5992 6.25 12.1223 6.25 11.625V3.75C6.25 2.95435 5.93393 2.19129 5.37132 1.62868C4.80871 1.06607 4.04565 0.75 3.25 0.75C2.45435 0.75 1.69129 1.06607 1.12868 1.62868C0.56607 2.19129 0.25 2.95435 0.25 3.75V13.125C0.25 14.219 0.684597 15.2682 1.45818 16.0418C2.23177 16.8154 3.28098 17.25 4.375 17.25C5.46902 17.25 6.51823 16.8154 7.29182 16.0418C8.0654 15.2682 8.5 14.219 8.5 13.125V4.5H7.375Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAttachment);
export default __webpack_public_path__ + "static/media/ic_attachment.ce42c73898822366226b49d7f78e99c9.svg";
export { ForwardRef as ReactComponent };